import template_01 from "./templates/template_01.js"
import template_02 from "./templates/template_02.js"
import template_03 from "./templates/template_03.js"
import template_04 from "./templates/template_04.js"
import template_05 from "./templates/template_05.js"
import template_06 from "./templates/template_06.js"
import template_07 from "./templates/template_07.js"
import template_08 from "./templates/template_08.js"
import template_09 from "./templates/template_09.js"
import template_10 from "./templates/template_10.js"
import template_11 from "./templates/template_11.js"
import template_12 from "./templates/template_12.js"
import template_13 from "./templates/template_13.js"
import template_a1 from "./templates/template_a1.js"
import template_a2 from "./templates/template_a2.js"
import template_a3 from "./templates/template_a3.js"
import template_a4 from "./templates/template_a4.js"
import template_a5 from "./templates/template_a5.js"
import template_a6 from "./templates/template_a6.js"
import template_a7 from "./templates/template_a7.js"
import template_a8 from "./templates/template_a8.js"
import template_a9 from "./templates/template_a9.js"

export default {
	template_01,
	template_02,
	template_03,
	template_04,
	template_05,
	template_06,
	template_07,
	template_08,
	template_09,
	template_10,
	template_11,
	template_12,
	template_13,
	template_a1,
	template_a2,
	template_a3,
	template_a4,
	template_a5,
	template_a6,
	template_a7,
	template_a8,
	template_a9
}
